import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../../utility/SweetAlert'

const InteractorFundAccountBankUpdate = () => {
  const { t } = useTranslation()
  const fundAccountBankUpdate = useCallback(
    (payload, loading, bank_account_holder_name) => {
      confirmationAlert({
        message: `${t('message.confirm_verification')} ${bank_account_holder_name} ?`,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/fund-account/bank-update', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_updated'),
                timer: 1500,
                redirect: '/fund/account-bank/manage',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { fundAccountBankUpdate }
}

export default InteractorFundAccountBankUpdate
